export const MEMBERSHIP_REJECTION_REASONS = [
  {
    id: 'not_aligned_with_community_focus',
    label: 'Not aligned with community focus',
    description: 'This community is designed for different interests and goals.',
  },
  {
    id: 'community_fit_mismatch',
    label: 'Community fit mismatch',
    description:
      "We're prioritizing members whose interests align more closely with current discussions.",
  },
  {
    id: 'eligibility_requirements_not_met',
    label: 'Eligibility requirements not met',
    description: 'The community has specific participation requirements.',
  },
  {
    id: 'gender_eligibility_requirements',
    label: 'Gender eligibility requirements',
    description: 'The community has member access restrictions.',
  },
  {
    id: 'other',
    label: 'Other',
    description: null,
  },
];

export const OTHER_DECLINE_REASON_CODE = 'other';

export const buildDeclineJoinRequestPayload = ({ declineReasonCode, declineReasonText = '' }) => {
  const code = String(declineReasonCode ?? '').trim();
  if (!code) {
    throw new Error('A decline reason is required.');
  }

  if (code === OTHER_DECLINE_REASON_CODE) {
    const text = String(declineReasonText ?? '').trim();
    if (!text) {
      throw new Error('Please provide a specific reason.');
    }
    return {
      declineReasonCode: code,
      declineReasonText: text,
    };
  }

  return { declineReasonCode: code };
};

export const getDeclineReasonLabel = (declineReasonCode) =>
  MEMBERSHIP_REJECTION_REASONS.find((option) => option.id === declineReasonCode)?.label ?? '';
